import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { PrevailingWageRatesComponent } from './prevailing-wage-rates/prevailing-wage-rates.component';
import { CurrencyInputModule } from 'src/shared/currency-input/currency-input.module';
import { PrevailingWageInformationComponent } from './prevailing-wage-info/prevailing-wage-info.component';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
		CurrencyInputModule,
		TextMaskModule,
	],
	declarations: [
		PrevailingWageInformationComponent,
		PrevailingWageRatesComponent,
	],
	exports: [PrevailingWageInformationComponent, PrevailingWageRatesComponent],
})
export class PrevailingWageModule {}
